import { CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetPasswordChangedState } from "../../redux/slices/passwordChangedSlice";
import { Button, Card } from "antd";
import "./PasswordChanged.css";

const PasswordChanged = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const basePath = sessionStorage.getItem('APP_BASE_PATH')
  const handleLogin = () => {
    dispatch(resetPasswordChangedState());
    navigate(`${basePath}/login`);
  };

  return (
    <div className="success-container">
      <Card className="success-box">
        <CheckCircleOutlined className="success-icon" /> {/* ✅ Ant Design Icon */}
        <h2 className="success-message">Password Changed Successfully!</h2>
        <Button type="primary" className="login-button" onClick={handleLogin}>
          Login Now
        </Button>
      </Card>
    </div>
  );
};

export default PasswordChanged; // ✅ Ensure correct export
